import {App} from './app';
import 'firebase/messaging';

export const Messaging = App.messaging();